const KEY = "edu.form-return.v1";
const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export function rememberFormRoute(path: string) {
  const match = /^\/forms\/([^/]+)$/.exec(path);
  const slug = match?.[1];
  if (!slug || slug.length < 3 || slug.length > 80 || !slugPattern.test(slug)) return;
  try {
    sessionStorage.setItem(KEY, slug);
  } catch {
    /* A navegação permanece disponível sem storage. */
  }
}
export function pendingFormRoute() {
  try {
    const slug = sessionStorage.getItem(KEY);
    return slug && slug.length >= 3 && slug.length <= 80 && slugPattern.test(slug)
      ? { to: "/forms/$slug" as const, params: { slug } }
      : null;
  } catch {
    return null;
  }
}
export function clearFormRoute(slug: string) {
  try {
    if (sessionStorage.getItem(KEY) === slug) sessionStorage.removeItem(KEY);
  } catch {
    /* Storage opcional. */
  }
}
